import { ReactNode, SyntheticEvent } from 'react';

import styled from '@emotion/styled';

import { NoProductImageLogo } from '../../../images';
import COLOR from '../../../constant/colorset';

const Container = styled.div`
  overflow: hidden;
  position: relative;
  background-color: ${COLOR.kurlyGray150};
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.5s ease-in-out
  }
  :hover > img {
    transform: scale(1.02);
    transition: all 0.3s ease-in-out
  }
`;

interface Props {
  imageUrl: string;
  children?: ReactNode;
  className?: string;
}

export default function ProductCardImage({
  imageUrl, children, className,
}: Props) {
  const handleImgError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = NoProductImageLogo;
  };

  return (
    <Container className={className}>
      <img src={imageUrl} alt={'상품 이미지'} loading="lazy" onError={handleImgError}/>
      {children}
    </Container>
  );
}
